/**
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */
import axios from 'axios';
import { api, util } from '@keystone/common';

export function isValidUserforRules(loggedInUserEmaild) {
  if (
    process.env.REACT_APP_USER_EMAIL_ID === '' ||
    process.env.REACT_APP_USER_EMAIL_ID === undefined
  ) {
    if (loggedInUserEmaild.toLowerCase() === 'vocadmin@honeywell.com') {
      return true;
    }
    return false;
  }
  if (process.env.REACT_APP_USER_EMAIL_ID.toLowerCase() === loggedInUserEmaild.toLowerCase()) {
    return true;
  }
  return false;
}

/**
 * A class for performing API calls to various back end services
 */
class ApiClient {
  home = (token) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/home`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  createSLA = (createSLAForm, user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/addRequest`, {
        method: 'post',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${user.idToken}`,
        },
        body: JSON.stringify(createSLAForm),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  createRule = (createRuleForm, user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/rule`, {
        method: 'post',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${user.idToken}`,
        },
        body: JSON.stringify(createRuleForm),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  editRule = (editRuleForm, user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/rule`, {
        method: 'put',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${user.idToken}`,
        },
        body: JSON.stringify(editRuleForm),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  deleteRules = (rulesNames, user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/rule`, {
        method: 'delete',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${user.idToken}`,
        },
        body: JSON.stringify(rulesNames),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchRules = (user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/rule`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchHistory = (user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/history`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchAllSLAs = (user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/getAllRequests`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  scanVad = (data, user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/artisan/vad/uploadNew`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
        body: data,
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  scanTask = (data, user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/devkit/task/uploadTaskFile`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
        body: data,
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  downloadTaskFile = (fileDir, fileName, user) =>
    new Promise((resolve, reject) => {
      fetch(
        `${util.getAPIGatewayURL()}/vactool/devkit/task/downloadGWSFile?GWSFileDir=${fileDir}&GWSFileName=${fileName}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${user.idToken}`,
          },
        }
      )
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a); // append to DOM (for firefox)
          a.click();
          a.remove();
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });

  downloadTaskFileAxios = (fileDir, fileName, user, updateFunc) => {
    return axios
      .request({
        url: `${util.getAPIGatewayURL()}/vactool/devkit/task/downloadGWSFile?GWSFileDir=${fileDir}&GWSFileName=${fileName}`,
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
        onDownloadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          const percent = (loaded / total) * 100;
          updateFunc('downloadPercent', percent.toFixed(0));
        },
        responseType: 'blob',
      })
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a); // append to DOM (for firefox)
        a.click();
        a.remove();
      });
  };

  deleteTaskConversionProject = (taskId, user) => {
    return fetch(`${util.getAPIGatewayURL()}/vactool/devkit/task/project?taskId=${taskId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${user.idToken}`,
      },
    });
  };

  fetchTaskHistory = (user) => {
    return fetch(`${util.getAPIGatewayURL()}/vactool/devkit/task/uploadHistory`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${user.idToken}`,
      },
    }).then((response) => {
      return api.validateResponse(response, 'VCAT');
    });
  };

  validateUser = (loggedInUserEmaild) => {};

  checkSLAId = (id) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/sla/check?id=${id}`)
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  submitSLA = (body) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/sla/submit`, {
        method: 'post',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  fetchConfiguration = (user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/admin/configuration`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  saveConfiguration = (emails, user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/admin/configuration`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${user.idToken}`,
        },
        body: JSON.stringify(emails),
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  uploadSLA = (sla, user) => {
    return new Promise((resolve, reject) => {
      fetch(`${util.getAPIGatewayURL()}/vactool/admin/uploadSLA`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
        body: sla,
      })
        .then(async (response) => {
          resolve(api.validateResponse(response, 'VCAT'));
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getUserPermissions = (user) => {
    return fetch(`${util.getAPIGatewayURL()}/vactool/features/userPermissions`, {
      method: 'get',
      headers: {
        Authorization: `Bearer ${user.idToken}`,
      },
    }).then((resp) => {
      return api.validateResponse(resp, 'VCAT');
    });
  };

  getFeatureList = (user) => {
    return fetch(`${util.getAPIGatewayURL()}/vactool/features/list`, {
      method: 'get',
      headers: {
        Authorization: `Bearer ${user.idToken}`,
      },
    }).then((resp) => {
      return api.validateResponse(resp, 'VCAT');
    });
  };

  getAllPermissions = (user) => {
    return fetch(`${util.getAPIGatewayURL()}/vactool/features/allPermissions`, {
      method: 'get',
      headers: {
        Authorization: `Bearer ${user.idToken}`,
      },
    }).then((resp) => {
      return api.validateResponse(resp, 'VCAT');
    });
  };

  updatePermissions = (permissions, user) => {
    return fetch(`${util.getAPIGatewayURL()}/vactool/features/updatePermissions`, {
      method: 'post',
      headers: {
        Authorization: `Bearer ${user.idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(permissions),
    }).then((resp) => {
      return api.validateResponse(resp, 'VCAT');
    });
  };

  deletePermissions = (permissions, user) => {
    return fetch(`${util.getAPIGatewayURL()}/vactool/features/deletePermissions`, {
      method: 'post',
      headers: {
        Authorization: `Bearer ${user.idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(permissions),
    }).then((resp) => {
      return api.validateResponse(resp, 'VCAT');
    });
  };
}

export default new ApiClient();
